import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Space } from 'antd';
import ConfirmRevisionModal from './ConfirmRevisionModal';

function CommercialActions({
  product,
  toggleDisableField,
  handleCommissionCalculatorModal,
  handleRequestChange,
  hanldeRevisionModal,
  confirmRevisisionModal,
  hanldeOnCancelRequest,
  handleFormSubmit,
  loading
}) {
  return (
    <Space>
      {product === 'Wire' && (
        <Button
          size="large"
          style={{
            marginTop: '10px',
            marginBottom: '10px',
            borderColor: 'var(--color-primary)',
            color: 'var(--color-primary)'
          }}
          onClick={handleCommissionCalculatorModal}
        >
          Commission Calculator
        </Button>
      )}

      {toggleDisableField ? (
        <Form.Item
          style={{
            marginTop: '10px',
            marginBottom: '10px'
          }}
        >
          <Button type="primary" onClick={handleRequestChange} size="large">
            Request Revision
          </Button>
        </Form.Item>
      ) : (
        <>
          <Button onClick={handleRequestChange} size="large">
            Cancel
          </Button>
          <Button type="primary" onClick={hanldeRevisionModal} size="large">
            Submit
          </Button>
        </>
      )}

      <ConfirmRevisionModal
        onCancel={hanldeOnCancelRequest}
        isVisible={confirmRevisisionModal}
        onSubmit={handleFormSubmit}
        loading={loading}
      />
    </Space>
  );
}

CommercialActions.propTypes = {
  product: PropTypes.string.isRequired,
  toggleDisableField: PropTypes.bool.isRequired,
  handleCommissionCalculatorModal: PropTypes.func.isRequired,
  handleRequestChange: PropTypes.func.isRequired,
  hanldeRevisionModal: PropTypes.func.isRequired,
  confirmRevisisionModal: PropTypes.bool.isRequired,
  hanldeOnCancelRequest: PropTypes.func.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

CommercialActions.defaultProps = {
  loading: false
};

export default CommercialActions;
